/**
 * Retired 2021 plan ids still present in published registration links, mapped to the
 * 2026 plans that replace them. Keys must stay lower-case — lookup is case-insensitive.
 */
export const LEGACY_BILLING_PLAN_MAP: Readonly<Record<string, string>> = Object.freeze({
    '2021-basis-edition-monthly': '2026-Basis-Edition-EUR-Monthly',
    '2021-basis-edition-yearly': '2026-Basis-Edition-EUR-Yearly',
    '2021-business-edition-monthly': '2026-Business-Edition-EUR-Monthly',
    '2021-business-edition-yearly': '2026-Business-Edition-EUR-Yearly',
    '2021-professional-edition-monthly': '2026-Professional-Edition-EUR-Monthly',
    '2021-professional-edition-yearly': '2026-Professional-Edition-EUR-Yearly'
});

/**
 * Returns the 2026 replacement for a retired plan id, or null when the id is not a
 * legacy one (unknown and already-2026 ids are left for the server to validate).
 */
export function resolveLegacyBillingPlan(plan: string | undefined | null): string | null {
    const key = (plan || '').trim().toLowerCase();
    return Object.prototype.hasOwnProperty.call(LEGACY_BILLING_PLAN_MAP, key)
        ? LEGACY_BILLING_PLAN_MAP[key]
        : null;
}

export interface SignUpFormData {
    firstName: string;
    lastName: string;
    email: string;
    recaptchaResponse?: string;
    billingPlan?: string;
    language?: string;
    gclid?: string | null;
    ucc?: string | null;
}

export interface SignUpApiPayload {
    first_name: string;
    last_name: string;
    email: string;
    recaptcha_response?: string;
    billing_plan?: string;
    language?: string;
    gclid?: string;
    ucc?: string;
}

export function toSignUpApiPayload(data: SignUpFormData): SignUpApiPayload {
    const payload: SignUpApiPayload = {
        first_name: data.firstName,
        last_name: data.lastName,
        email: data.email.toLowerCase(),
        recaptcha_response: data.recaptchaResponse
    };
    if (data.billingPlan) {
        payload.billing_plan = data.billingPlan;
    }
    if (data.language) {
        payload.language = data.language;
    }
    if (data.gclid) {
        payload.gclid = data.gclid;
    }
    if (data.ucc) {
        payload.ucc = data.ucc;
    }
    return payload;
}
